import { Stack, Typography } from "@mui/material";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Hunter.Dashboard.Prerequisites;

export const HunterPrerequisitesWidgetError = () => {
  const { t } = useResource();

  return (
    <PrimaryPaper>
      <Stack spacing={4}>
        <Typography variant="h6" fontWeight={600} textTransform="uppercase">
          {t(RESOURCES.Title)}
        </Typography>
        <Typography color="text.secondary">
          {t(RESOURCES.Description)}
        </Typography>
        <ErrorText>{t(Resources.Errors.DataLoadingError)}</ErrorText>
      </Stack>
    </PrimaryPaper>
  );
};
